import React from 'react';
import {
  BrowserRouter,
  MemoryRouter,
  Route,
  RouteProps,
  Switch,
  useHistory
} from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';

import { FeatureTogglesProvider } from 'context/FeatureTogglesProvider';
import * as Pages from 'pages';
import { constants } from 'utils';

import { trackEvent } from '../utils/analytics';

const {
  Routes: { CheckIn, Register, RegistrationSuccess, Verify }
} = constants;
const intialRoutes = [CheckIn, Register, RegistrationSuccess, Verify];

const CustomRoute: React.FC<RouteProps> = props => {
  const {
    location: { pathname }
  } = useHistory();

  React.useEffect(() => {
    const RouteName = Object.keys(constants.Routes).find(key => constants.Routes[key] === pathname);
    trackEvent({
      label: `Navigation - ${RouteName}`,
      action: pathname !== constants.Routes.CheckIn ? 'KioskAdmin' : 'KioskCheckIn',
      data: {
        pathname
      }
    });
  }, [pathname]);
  return <Route {...props} />;
};

export default function Routes() {
  return (
    <BrowserRouter basename={process.env.REACT_APP_BASENAME}>
      <QueryParamProvider ReactRouterRoute={Route}>
        <FeatureTogglesProvider>
          <Switch>
            <CustomRoute path='*'>
              <Pages.NoLongerRequired />
            </CustomRoute>
            <CustomRoute exact path={constants.Routes.About}>
              <Pages.About />
            </CustomRoute>
            <Route>
              <MemoryRouter initialEntries={intialRoutes} initialIndex={0}>
                <Switch>
                  <CustomRoute exact path={constants.Routes.CheckIn}>
                    <Pages.CheckIn />
                  </CustomRoute>
                  <CustomRoute exact path={constants.Routes.RegisteredLocation}>
                    <Pages.RegisteredLocation />
                  </CustomRoute>
                  <CustomRoute exact path={constants.Routes.Register}>
                    <Pages.Register />
                  </CustomRoute>
                  <CustomRoute exact path={constants.Routes.Verify}>
                    <Pages.Verify />
                  </CustomRoute>
                  <CustomRoute exact path={constants.Routes.RegistrationSuccess}>
                    <Pages.RegistrationSuccess />
                  </CustomRoute>
                </Switch>
              </MemoryRouter>
            </Route>
          </Switch>
        </FeatureTogglesProvider>
      </QueryParamProvider>
    </BrowserRouter>
  );
}
